var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroku(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#6762a6}")), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    d: "M158.7 431.5v-31.8c0-2.2-1.6-3.2-3.6-3.2-3.9 0-8.7 1-13.1 2.9v32.1h-9v-59h9V392c4.3-1.6 9.3-2.9 14.4-2.9 8.1 0 11.2 5 11.2 11.9v30.6zm25.6-19.3c.3 10.7 2.4 12.8 8.9 12.8 5.1 0 11-1.7 15.4-3.4l1.5 6.7c-4.8 2.2-10.6 4.3-17.5 4.3-14.9 0-17.2-8.2-17.2-21.3 0-7.2.5-13.7 2.2-19.6 4.5-1.7 10.4-2.6 18-2.6 12.2 0 16 6.8 16 18.7v4.6h-27.3zm11.3-15.7c-2.7 0-6.9.1-10.4.7-.4 1.8-.8 4.3-1 8.8h18.7c0-6.2-1.2-9.5-7.3-9.5m32.8 2.9v32.1h-9v-36.1c7.5-4.1 15.5-5.4 20.7-5.7v7.5c-3.6.2-8.2.6-11.7 2.2m35.4 33.1c-13.4 0-19.4-6.6-19.4-21.6 0-15.9 8-21.9 19.4-21.9 13.4 0 19.4 6.6 19.4 21.6 0 15.9-8 21.9-19.4 21.9m0-36c-6.9 0-10.7 4-10.7 14.5 0 11.5 3.2 14 10.7 14 6.9 0 10.7-3.9 10.7-14.4 0-11.5-3.2-14.1-10.7-14.1m62.6 35h-10.5c-2.5-6.6-5.9-13.3-11.2-19.1H300v19.1h-9v-59h9v33.9h4.2c4.6-4.7 8.1-10.5 10.5-16.3h10.1c-3.4 6.9-7.8 13.1-12.8 18.1 5.9 7.4 10.5 15.3 14.4 23.3m16.8 1c-8.1 0-11.2-5-11.2-11.9V390h8.9v31.7c0 2.2 1.6 3.2 3.6 3.2 3.9 0 9.2-1 13.6-2.9v-32h9v36c-10.7 5.8-18.9 6.5-23.9 6.5",
    className: "st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    d: "M339.2 357.4H160.7c-15.3 0-27.6-12.4-27.6-27.6V95.1c0-15.3 12.4-27.6 27.6-27.6h178.5c15.3 0 27.7 12.4 27.7 27.6v234.6c0 15.3-12.4 27.7-27.7 27.7",
    className: "st0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    d: "M279.6 317.5V202.4s7.5-27.6-92.2 11.3c-.2.5-.2-106.5-.2-106.5l32.6-.2v68.5s91.2-35.9 91.2 27.3v114.7zm18.5-169h-34.6c12.4-15.2 23.7-41.3 23.7-41.3H323s-6.1 17-24.9 41.3M187.7 317.3v-65.6l32.8 32.8z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroku);
export default __webpack_public_path__ + "static/media/heroku.365e9300b432695b8bce1437de965586.svg";
export { ForwardRef as ReactComponent };